// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"9d84ac99","769":"a47b4880"}[chunkId] + ".chunk.css";
};